import React, { Component } from 'react';
import { connect } from 'react-redux';
import './Banner.scss';

import MainLogo from '../../../assets/images/main-logo.png';
import LargeEight from '../../../assets/images/large-8.png';
import BannerCover from '../../../assets/images/bottom-banner-cover.png';

import BannerVideo from '../../../assets/video/background-vid.mp4';

class Banner extends Component {
  render() {
    return (
      <div>
        <section id="banner">
          <div className="video-background">
            <div className="video-cover-contain">
              <video className="banner-video" autoPlay>
                <source src={BannerVideo} />  
              </video>
              <div className="cover"></div>
            </div>

            <div id="top-logo-and-nav">
              <div className="container large-container">
                <div className="row justify-content-between">
                  <div className="col-4 col-md-4 col-sm-4 d-flex align-items-center">
                    <div className="main-logo">
                      <img src={MainLogo} alt="" />
                    </div>
                  </div>

                  <div className="col-md-8 col-sm-2 col-2 d-flex align-items-center justify-content-end">
                    <div className="main-nav text-right">
                      <div className="mobile-menu-icon">
                        <i className="fal fa-bars"></i>
                      </div>

                      <div className="menu-items">
                        <ul className="d-flex">
                          <li><a href="#"><span>01</span> Home</a></li>
                          <li><a href="#below-banner"><span>02</span> About</a></li>
                          <li><a href="#our-process"><span>03</span> Process</a></li>
                          <li><a href="#we-have-worked-with"><span>04</span> Our Customers</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div id="banner-content-holder">
              <div className="container">
                <div className="d-flex justify-content-between align-items-stretch">
                  <div className="left">
                    <h2>
                      <span className="line-one">We design &amp; develop</span>
                      <span className="line-two">Powerful digital experiences</span>
                    </h2>
                  </div>

                  <div className="right">
                    <img src={LargeEight} alt="" />
                  </div>
                </div>
              </div>
            </div>

            <div className="bottom-banner-cover">
              <img src={BannerCover} alt="" />
            </div>
          </div>
        </section>
      </div>
    )
  }
}

export default connect()(Banner);



// WEBPACK FOOTER //
// ./src/components/Common/Banner/Banner.js